export default "__VITE_ASSET__CRZvh5B6__"